module.exports = "/images/members-active.svg?ef1bc2cfbd2cf9c28a30f4c49a4e2d38";